<section class="modal-root modal-cookie-root mat-display-3">
  <div class="heading mat-display-2">Този сайт използва "бисквитки" (cookies).</div>
  <section class="content">
    <p class="mat-title">Разглеждайки съдържанието на сайта, вие се съгласявате с използването на "бисквитки".</p>
    <p class="mat-title">Повече информация <a class="primary" [routerLink]="['/privacy-policy']">тук</a></p>
  </section>
  <span (click)="handleCloseAncAcceptCookies($event)" class="actions contained-button"
    data-color="primary" data-source="root">OK</span>
</section>